export type AcaoVigilanciaCamera = 'nenhuma' | 'reproduzir' | 'destravar-analise' | 'reabrir' | 'lente-aberta';

export interface EstadoVigilanciaCamera {
  cameraAtiva: boolean;
  reabrindo: boolean;
  trilhaViva: boolean;
  videoPausado: boolean;
  videoSemQuadro: boolean;
  analiseTravadaMs: number;
}

export class ServicoVigilanciaCameraRegistrador {
  static readonly INTERVALO_MS = 1500;
  static readonly ANALISE_TRAVADA_MS = 2500;
  static readonly CICLOS_SEM_QUADRO_PARA_REABRIR = 3;
  static readonly CICLOS_ESCUROS_PARA_LENTE_FECHADA = 2;

  private ciclosSemQuadro = 0;
  private ciclosEscuros = 0;
  private lenteFechada = false;

  avaliar(estado: EstadoVigilanciaCamera): AcaoVigilanciaCamera {
    if (!estado.cameraAtiva || estado.reabrindo) {
      return 'nenhuma';
    }
    if (!estado.trilhaViva) {
      this.ciclosSemQuadro = 0;
      return 'reabrir';
    }
    if (estado.videoPausado) {
      return 'reproduzir';
    }
    if (estado.analiseTravadaMs >= ServicoVigilanciaCameraRegistrador.ANALISE_TRAVADA_MS) {
      return 'destravar-analise';
    }
    if (estado.videoSemQuadro) {
      this.ciclosSemQuadro += 1;
      if (this.ciclosSemQuadro >= ServicoVigilanciaCameraRegistrador.CICLOS_SEM_QUADRO_PARA_REABRIR) {
        this.ciclosSemQuadro = 0;
        return 'reabrir';
      }
      return 'nenhuma';
    }
    this.ciclosSemQuadro = 0;
    return 'nenhuma';
  }

  notificarQuadroEscuro(escuro: boolean): AcaoVigilanciaCamera {
    if (escuro) {
      this.ciclosEscuros += 1;
      if (this.ciclosEscuros >= ServicoVigilanciaCameraRegistrador.CICLOS_ESCUROS_PARA_LENTE_FECHADA) {
        this.lenteFechada = true;
      }
      return 'nenhuma';
    }
    this.ciclosEscuros = 0;
    if (this.lenteFechada) {
      this.lenteFechada = false;
      this.marcarLenteLiberada();
      return 'lente-aberta';
    }
    return 'nenhuma';
  }

  marcarLenteLiberada() {
    this.ciclosSemQuadro = 0;
    this.ciclosEscuros = 0;
    this.lenteFechada = false;
  }

  resetar() {
    this.ciclosSemQuadro = 0;
    this.ciclosEscuros = 0;
    this.lenteFechada = false;
  }
}
